<template>
  <div class="ln-button" :class="[type, disabled ? 'disabled' : '']">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'default'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.ln-button {
  padding: 0.2rem 0.4rem;
  border-radius: 0.1rem;
  font-size: 0.3rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;

  opacity: 1;
  transition: all 0.3s;
  &:active {
    opacity: 0.5;
  }

  &.default {
    color: #979696;
    border: 1px solid #979696;
  }

  &.disabled {
    pointer-events: none;
  }

  &.primary {
    background: #ffc100;
    color: #ffffff;
    &.disabled {
      background: #979696;
    }
  }
}
</style>
